import { render, staticRenderFns } from "./SimpleNumber.vue?vue&type=template&id=a0fa880c&scoped=true"
import script from "./SimpleNumber.vue?vue&type=script&lang=js"
export * from "./SimpleNumber.vue?vue&type=script&lang=js"
import style0 from "./SimpleNumber.vue?vue&type=style&index=0&id=a0fa880c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fa880c",
  null
  
)

export default component.exports